export default function TransportationOneStepSolution() {
    const data = [
        {
            img: 'swift_vehicle.png',
            title: 'Sedan Services',
            paragraph: 'Comfortable 4-seater cars ideal for daily office commutes and executive transfers.'
        },
        {
            img: 'innova_vehicle.png',
            title: 'SUV Transfers',
            paragraph: 'Spacious and reliable SUVs suited for team travel with added comfort and safety.'
        },
        {
            img: 'employee_vehicle.png',
            title: 'Employee Shuttle',
            paragraph: 'Large buses ranging up to 42-seaters for scheduled pick-ups and drop-offs across zones.'
        },
        {
            img: 'airport_car_vehicle.png',
            title: 'Airport Commutes',
            paragraph: 'On-time executive pickups and drops to major airports with real-time tracking support.'
        },
        {
            img: 'custom_fleet_vehicle.png',
            title: 'Custom Fleet Plans',
            paragraph: 'Flexible vehicle deployment tailored to company shift schedules and headcounts.'
        },
        {
            img: 'outstation-vehicle.png',
            title: 'Outstation Travel',
            paragraph: 'Comfortable outstation transportation for corporate teams with well-maintained vehicles.'
        }
    ];

    return (
        <div className="pt-14 pb-8 bg-white">
            <div className="text-center w-[95%] md:w-full">
                <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-indigo-900">
                    Complete Transportation Solutions for Modern Workforces
                </h2>
                <p className="text-sm md:text-base lg:text-lg mt-1">
                    Streamline your team’s daily travel with our professionally managed, reliable, and safe employee transport services.
                </p>
            </div>

            <div className="mt-4 md:mt-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-8 w-[90%] md:w-[95%] lg:w-[85%] mx-auto">
                    {data.map((vehicle, index) =>
                        <div key={index} className="flex justify-center items-start md:items-center shadow shadow-gray-100 p-1 rounded-xl">
                            <div className="w-[30%] relative bg-white">
                                <img src={`/${vehicle.img}`} alt={vehicle.title} width="100%" className="w-full h-full" />
                            </div>
                            <div className="flex-1">
                                <h4 className="text-base md:text-lg lg:text-xl font-medium md:font-semibold mt-4 md:mt-0">{vehicle.title}</h4>
                                <p className="text-sm md:text-sm lg:text-base mt-[2px] md:mt-1">{vehicle.paragraph}</p>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}